import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconKeyboardArrowDownLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 14.677a.831.831 0 0 1-.633-.256L6.873 9.927a.726.726 0 0 1-.213-.522.708.708 0 0 1 .213-.532.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217L12 12.946l4.073-4.073a.726.726 0 0 1 .522-.212.708.708 0 0 1 .532.212c.145.145.217.32.217.527a.718.718 0 0 1-.217.527l-4.494 4.494a.832.832 0 0 1-.633.256Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardArrowDownLine;
